exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-desafio[data-v-35b2bf17]{background:#ececec;border-radius:15px!important;border:0!important;align-items:center;transition:.2s;z-index:0;margin:10px}.card-desafio[data-v-35b2bf17]:hover{box-shadow:-1px 11px 16px 1px rgba(0,0,0,.32);transition:.2s;transform:scaleX(1.05) scaleY(1.05);z-index:1}.card-desafio-image[data-v-35b2bf17]{border-radius:10px;width:200px}@media screen and (max-width:600px){.card-desafio[data-v-35b2bf17]{width:250px;margin:20px}.card-desafio-image[data-v-35b2bf17]{border-radius:10px;width:250px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35b2bf17","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/arkidian/Arkidian.vue
// module id = 453
// module chunks = 0